module.exports = __webpack_public_path__ + "img/11-1.57ab0b09.jpg";